module.exports = __webpack_public_path__ + "img/RPCPool.c27eeb6f.webp";